<script setup lang="ts">
import { computed, defineProps } from 'vue';
import { NuxtLink } from '#components';

const props = defineProps<{
  title: string;
  to?: string;
  url?: string;
  href?: string;
  icon?: string;
  target?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}>();

const isExternal = computed(() => !!props.href);
const isButton = computed(
  () =>
    props.type === 'button' || props.type === 'submit' || props.type === 'reset'
);
</script>

<template>
  <component
    :is="isExternal ? 'a' : isButton ? 'button' : NuxtLink"
    :href="isExternal ? href : undefined"
    :to="!isExternal && !isButton ? url : undefined"
    :type="isButton ? type : undefined"
    :target="target ? target : undefined"
    :disabled="disabled ? disabled : undefined"
    :rel="target === '_blank' ? 'noopener noreferrer' : undefined"
    class="group inline-flex items-center bg-blue px-10 py-3 font-mono text-xxl uppercase tracking-wide text-white transition-all duration-300 hover:bg-black md:text-lg"
    :class="{ 'pointer-events-none': disabled }"
  >
    <span class="relative top-0.5">{{ title }}</span>
    <svg
      v-if="icon"
      class="ml-2 block h-4 w-3 transition-transform duration-300 group-hover:translate-x-1"
    >
      <use :href="`/icons/icons.svg#${icon}`" />
    </svg>
  </component>
</template>
